import type { SceneMeta } from '@/types';

// 港机码头运维 3D 场景元数据 v1
// 场景定位：集装箱桥式起重机全三维场景 —— 起升机构 + 小车运行 + 大车走行 + 吊具对位 + 防摇控制
// 复用 SceneMeta 通用格式；is3D=true 由 FactoryCanvas 路由到 PortCrane3D 组件
export const portcraneMeta: SceneMeta = {
  id: 'portcrane',
  name: '港机码头运维',
  shortName: '港机',
  icon: '🏗️',
  thumbnail: '/scenes/portcrane.jpg',
  description: '集装箱桥式起重机全三维场景 · 起升机构 · 小车运行 · 大车走行 · 吊具对位 · 防摇控制',
  // 3D 场景：designSize 仅作为 UI 浮层布局参考，实际 3D 渲染填满父容器
  designSize: { width: 1280, height: 760 },
  primaryColor: '#f97316',  // 港机橙 —— 与码头岸桥主结构涂装一致
  difficulty: 'advanced',
  status: 'available',
  is3D: true,
};
